import React from 'react';
import { useTranslation } from 'react-i18next';

import filmImg from './img/film.webp';
import batteryImg from './img/battery.webp';
import pcbImg from './img/pcb.webp';
import nonwovenImg from './img/nonwoven.webp';
import metalImg from './img/metal.webp';
import paperImg from './img/paper.webp';
import solarImg from './img/solar.webp';
import generalImg from './img/glass.webp';

function SolutionsSection() {
  const { t, i18n } = useTranslation();

  const solutionsData = [
    {
      id: 'film',
      title: t('solutions.film.title'),
      description: t('solutions.film.description'),
      image: filmImg,
      link: '/solutions/film',
    },
    {
      id: 'battery',
      title: t('solutions.battery.title'),
      description: t('solutions.battery.description'),
      image: batteryImg,
      link: '/solutions/battery',
    },
    {
      id: 'pcb',
      title: t('solutions.pcb.title'),
      description: t('solutions.pcb.description'),
      image: pcbImg,
      link: '/solutions/pcb',
    },
    {
      id: 'nonwoven',
      title: t('solutions.nonwoven.title'),
      description: t('solutions.nonwoven.description'),
      image: nonwovenImg,
      link: '/solutions/nonwoven',
    },
    {
      id: 'metal',
      title: t('solutions.metal.title'),
      description: t('solutions.metal.description'),
      image: metalImg,
      link: '/solutions/metal',
    },
    {
      id: 'paper',
      title: t('solutions.paper.title'),
      description: t('solutions.paper.description'),
      image: paperImg,
      link: '/solutions/paper',
    },
    {
      id: 'solar',
      title: t('solutions.solar.title'),
      description: t('solutions.solar.description'),
      image: solarImg,
      link: '/solutions/solar',
    },
    {
      id: 'general',
      title: t('solutions.general.title'),
      description: t('solutions.general.description'),
      image: generalImg,
      link: '/solutions/glass',
    },
  ];

  const isEnglish = i18n.language === 'en';

  return (
    <section className="solution-section py-16 bg-gray-100 text-gray-900 dark:text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          {!isEnglish && (
            <h2 className="title-style text-4xl font-extrabold text-gray-800 dark:text-white sm:text-3xl">
              OUR SOLUTION
            </h2>
          )}
          <p className={`text-xl text-blue-600 font-medium ${!isEnglish ? 'mt-2' : ''} sm:text-lg zh-title-style`}>
            {t('solutions.sectionTitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {solutionsData.map((solution) => (
            <a
              key={solution.id}
              href={solution.link}
              className="group relative block w-full h-64 overflow-hidden rounded-lg shadow-lg
                         transform transition-transform duration-300 hover:scale-105 hover:shadow-xl
                         focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              <img
                src={solution.image}
                alt={solution.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-70 transition-opacity duration-300"></div>

              <div className="relative p-6 flex flex-col justify-end h-full">
                <h3 className="text-2xl font-bold text-white mb-2 leading-tight group-hover:text-blue-200 transition-colors duration-300 sm:text-xl">
                  {solution.title}
                </h3>
                <p className="text-gray-200 text-base opacity-0 group-hover:opacity-100 transition-opacity duration-300 sm:opacity-100 sm:text-sm">
                  {solution.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SolutionsSection;
